module.exports = __webpack_public_path__ + "img/1477221734.18612668.jpg";